import { render, staticRenderFns } from "./Ticketera.vue?vue&type=template&id=52a2eddf&"
import script from "./Ticketera.vue?vue&type=script&lang=js&"
export * from "./Ticketera.vue?vue&type=script&lang=js&"
import style0 from "./Ticketera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports